import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    title: _ctx.full ? undefined : _ctx.plain,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (!piece.tag)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(piece.text), 1)
            ], 64))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(piece.tag), {
              key: 1,
              class: _normalizeClass(piece.classes),
              style: _normalizeStyle(piece.style),
              href: piece.href,
              target: piece.external ? '_blank' : undefined,
              rel: piece.external ? 'noopener' : undefined
            }, {
              default: _withCtx(() => [
                (piece.prefix)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "md-mention-prefix",
                      innerHTML: piece.prefix
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(piece.text), 1)
              ]),
              _: 2
            }, 1032, ["class", "style", "href", "target", "rel"]))
      ], 64))
    }), 128))
  ], 8, _hoisted_1))
}